import React, { memo } from 'react'
import { Box, Card, Link, Stack } from '@mui/material'
import { Trans } from 'react-i18next'

import CardHeading from '../text/CardHeading'
import brandConfig from 'brandConfig'
import Text from '../text/Text'
import { NAVIGATION_BLANK_PARAMS } from '../../util/navigation.helpers'

const WhatArePoints = ({ t, symbol }) => {
  const earnLabels = ['staking', 'quests', 'reward-boxes', 'cashback']
  const spendLabels = ['items', 'exchange', 'online-store']
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CardHeading
        title={t('home.what-are-points', { symbol })}
        desc={t('home.what-are-points-desc', {
          name: brandConfig.name,
          symbol
        })}
      />
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <Text
            label={t('home.how-can-you-earn', { symbol })}
            color='inherit'
            variant='body1'
          />
          <Text
            variant='body2'
            label={
              <Box component='ul' pl={1.5}>
                {earnLabels.map((label) => (
                  <li key={label}>
                    {t(`brand:what-are.how-to-earn.${label}`)}
                  </li>
                ))}
              </Box>
            }
            component='div'
            color='text.secondary'
          />
        </Stack>
        <Stack spacing={0.5}>
          <Text
            label={t('home.how-can-you-spend', { symbol })}
            color='inherit'
            variant='body1'
          />
          <Text
            variant='body2'
            label={
              <Box component='ul' pl={1.5}>
                {spendLabels.map((label) => (
                  <li key={label}>
                    {t(`brand:what-are.how-to-spend.${label}`)}
                  </li>
                ))}
              </Box>
            }
            component='div'
            color='text.secondary'
          />
        </Stack>
        <Text
          variant='body2'
          label={
            <Trans i18nKey='home.learn-more'>
              <Link
                href={brandConfig.helpCenterUrl}
                {...NAVIGATION_BLANK_PARAMS}
              />
            </Trans>
          }
          component='div'
          color='text.secondary'
        />
      </Stack>
    </Card>
  )
}

export default memo(WhatArePoints)
